(() => {
  const initialize = grid => {
    if (grid.dataset.flipReady) return;
    grid.dataset.flipReady = 'true';
    const cards = [...grid.querySelectorAll('[data-sm-flip-card]')];
    const setFlipped = (card, flipped, returnFocus = false) => {
      const toggle = card.querySelector('.sm-flip-toggle');
      const front = card.querySelector('.sm-flip-front');
      const back = card.querySelector('.sm-flip-back');
      if (!toggle || !front || !back) return;
      card.dataset.flipped = String(flipped);
      front.inert = flipped;
      front.setAttribute('aria-hidden', String(flipped));
      back.inert = !flipped;
      back.setAttribute('aria-hidden', String(!flipped));
      toggle.setAttribute('aria-expanded', String(flipped));
      const label = flipped ? toggle.dataset.artworkLabel : toggle.dataset.detailsLabel;
      toggle.querySelector('span').textContent = label;
      toggle.setAttribute('aria-label', label + ' — ' + card.dataset.title);
      if (returnFocus) toggle.focus({preventScroll: true});
    };
    cards.forEach(card => {
      const toggle = card.querySelector('.sm-flip-toggle');
      if (!toggle) return;
      toggle.hidden = false;
      card.querySelectorAll('.sm-flip-front a[href]').forEach(link => link.tabIndex = 0);
      setFlipped(card, false);
      toggle.addEventListener('click', () => {
        const opening = card.dataset.flipped !== 'true';
        cards.forEach(other => { if (other !== card && other.dataset.flipped === 'true') setFlipped(other, false); });
        setFlipped(card, opening);
        if (opening) card.querySelector('.sm-flip-description').focus({preventScroll: true});
      });
    });
    grid.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const card = event.target.closest('[data-sm-flip-card][data-flipped=true]');
      if (!card) return;
      event.preventDefault();
      setFlipped(card, false, true);
    });
    const observer = new MutationObserver(records => {
      records.forEach(({target}) => {
        if (target.hidden && target.dataset.flipped === 'true') setFlipped(target, false);
      });
    });
    cards.forEach(card => observer.observe(card, {attributes: true, attributeFilter: ['hidden']}));
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(grid)) observer.disconnect();
    }, {once: true});
  };
  const scan = root => root.querySelectorAll('[data-sm-flip-grid]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once: true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

(() => {
  const setup = () => {
    document.querySelectorAll('#sm-catalog [data-sm-flip-grid]').forEach(grid => {
      if (grid.dataset.cartIconsReady) return;
      grid.dataset.cartIconsReady = 'true';
      let pending = null;
      grid.querySelectorAll('.sm-catalog-add:not(:disabled)').forEach(button => {
        const tooltip = document.createElement('span');
        tooltip.className = 'sm-grid-tooltip';
        tooltip.setAttribute('aria-hidden', 'true');
        tooltip.textContent = (button.getAttribute('aria-label') || '').split(' — ')[0];
        const check = document.createElement('span');
        check.className = 'sm-grid-check';
        check.setAttribute('aria-hidden', 'true');
        button.append(tooltip, check);
      });
      grid.addEventListener('submit', event => {
        const button = event.target.querySelector('.sm-catalog-add');
        if (button) pending = button;
      }, true);
      document.addEventListener('ajaxProduct:error', () => { pending = null; });
      document.addEventListener('ajaxProduct:added', event => {
        if (!pending) return;
        const product = event.detail?.product;
        const id = product?.variant_id || product?.id || product?.items?.[0]?.id;
        if (String(id) !== pending.dataset.variantId) return;
        const button = pending;
        pending = null;
        button.dataset.smAdded = 'true';
        window.setTimeout(() => { delete button.dataset.smAdded; }, 2200);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
